import { RouteType } from "types/RouteType";
import ModulesStore from "./ModulesStore";

/**
 * The governed catalog list — one row per `module_catalog` entry, joined to the
 * `module-summary` rollup. Modules, tools and integrations all live here; kind
 * is a header facet, not a separate route.
 *
 * NO DIALOGS, deliberately: every governed field is sync-owned (`yarn
 * catalog:sync` is the only writer, and the API leaves those columns out of the
 * data/patch schemas entirely). HQ mirrors, never invents — a "New module"
 * button here would mint an identity the Coordinator does not know about.
 * Ownership and other editable facts are written from ModuleDetail's tabs.
 */
const modulesRoute: RouteType[] = [
  {
    name: "Modules",
    path: "/modules",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Modules",
        enableRefreshButton: true,
        component: () => import("./Modules.Header"),
      },
      body: {
        component: () => import("./Modules.Body"),
        grayBackground: true,
      },
    },
    group: "Modules",
    // Omnibar tokens: nobody searches for the table name. "catalog" is what the
    // Coordinator calls it, and the page serves tools/integrations too, so the
    // words a user would actually type all have to land here.
    searchAliases: [
      "catalog",
      "module catalog",
      "governed repos",
      "repos",
      "tools",
      "integrations",
      "packages",
      "governance",
    ],
    // RBAC seam: reads require authentication only. The API service enforces
    // the operator-or-admin gate on writes (and refuses external writes to the
    // sync-owned tables outright), so this route is intentionally not
    // admin-only — viewers browse the catalog.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      // Loads the whole catalog + the module-summary rollup and subscribes to
      // live module CRUD events (idempotent — the header Refresh re-runs this).
      const store = rootStore.modulesStore as ModulesStore;
      void store?.initialize();
    },
    onExit: ({ rootStore }) => {
      // Tear down the realtime subscription (refcounted shared socket).
      const store = rootStore.modulesStore as ModulesStore;
      store?.dispose();
    },
  },
];

export default modulesRoute;
